/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, Flex, message } from "antd";
import { Row, Col, Space, InputNumber, Divider, Badge, Select } from "antd";

import { SaveFilled, SearchOutlined } from "@ant-design/icons";

import { ButtonBack } from "../../../components/button";
import ModalUnit from "../../../components/modal/ERP/unit/ModalUnit.jsx";

import { immaster } from "./model";
import IndirectMaterialService from "../../../service/ERP/IndirectMaterial.service";
import { useLocation, useNavigate } from "react-router";
import { delay } from "../../../utils/util";

const imService = IndirectMaterialService();

const from = "/ERP/indirect-material";

const IndirectMaterialManage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const [form] = Form.useForm();

  const [formDetail, setFormDetail] = useState(immaster);
  const [openModalUnit, setOpenModalUnit] = useState(false);

  /* โหมดดูอย่างเดียว — ปิดการแก้ไขทั้งฟอร์ม ซ่อนปุ่มบันทึก */
  const isView = config?.action === "view";

  const init = async () => {
    if (config?.action !== "create") {
      imService
        .get(config?.code)
        .then(async (res) => {
          const { data: detail } = res.data;
          const initialValues = { ...immaster, ...detail };

          setFormDetail(initialValues);
          form.setFieldsValue(initialValues);
        })
        .catch((err) => {
          const data = err?.response?.data;
          message.error(data?.message || "error request");
        });
    } else {
      setFormDetail(immaster);
      form.setFieldsValue(immaster);
    }
  };

  useEffect(() => {
    init();
    return () => {};
  }, []);

  const handleChoosedUnit = (value) => {
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      unit: value.unitname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleConfirm = () => {
    form.validateFields().then((v) => {
      const parm = {
        ...formDetail,
        ...form.getFieldsValue(),
      };
      const actions =
        config?.action !== "create"
          ? imService.update(parm)
          : imService.create(parm);

      actions
        .then(async () => {
          message.success("Request success.");
          navigate(from, { replace: true });
          await delay(300);
        })
        .catch((err) => {
          const data = err?.response?.data;
          message.error(data?.message || "error request");
        });
    });
  };

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>ข้อมูลหลัก</Divider>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item
            label="Indirect Material Code"
            name="im_code"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input
              placeholder="Enter Indirect Material Code."
              readOnly={config?.action !== "create"}
              className={config?.action !== "create" ? "!bg-zinc-100" : ""}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item
            label="Indirect Material Name"
            name="im_name"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input placeholder="Enter Indirect Material Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="Indirect Material Name (English)" name="im_nameEN">
            <Input placeholder="Enter Indirect Material Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="Express Name" name="express_name">
            <Input placeholder="Enter Express Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="ชื่อที่ใช้สั่งซื้อ" name="purchase_name">
            <Input placeholder="Enter Purchase Name." />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Form.Item label="หน่วยสินค้า :" name="unit">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Unit"
                value={!!formDetail.unit ? `${formDetail.unit} ` : ""}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalUnit(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col
          xs={24} sm={24} md={12} lg={12} xl={8}
          style={
            config?.action === "edit" || config?.action === "view"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานะการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "เปิดการใช้งาน",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "ปิดการใช้งาน",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider {...dividerProp}>ข้อมูลใช้คำนวน</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="min_stock" label="สต๊อกขั้นต่ำ">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              placeholder="ใส่จำนวนสต๊อกขั้นต่ำ"
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider {...dividerProp}>อื่นๆ</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <Form.Item label="Remark" name="remark">
            <Input.TextArea placeholder="Enter Remark." rows={5} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionAction = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      {!isView && (
        <Col span={12} style={{ paddingInline: 0 }}>
          <Flex gap={4} justify="end">
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              Save
            </Button>
          </Flex>
        </Col>
      )}
    </Row>
  );

  return (
    <div className="packaging-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        {SectionAction}
        <Form form={form} layout="vertical" autoComplete="off" disabled={isView}>
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionAction}
      </Space>

      {openModalUnit && (
        <ModalUnit
          show={openModalUnit}
          close={() => {
            setOpenModalUnit(false);
          }}
          values={(v) => {
            handleChoosedUnit(v);
          }}
        />
      )}
    </div>
  );
};

export default IndirectMaterialManage;
